import type { TemplatePackage } from '@cogo/template'
import { applianceHidesCommerceMarker } from '@/services/appliance-commerce-surface'
import bakeryPkg from './registry/bakery-storefront.template.json'
import bakeryFiles from './registry/bakery-storefront.files.json'

export interface TemplateRegistryFileEntry { path: string; sha256: string }
export interface TemplateRegistryEntry {
  pkg: TemplatePackage
  basePath: string
  files: TemplateRegistryFileEntry[]
  displayName: string
}

const TEMPLATE_REGISTRY_ALL: TemplateRegistryEntry[] = [
  {
    pkg: bakeryPkg as unknown as TemplatePackage,
    basePath: '/apps/bakery-shop-new3',
    files: bakeryFiles as TemplateRegistryFileEntry[],
    displayName: '베이커리 스토어프론트',
  },
]

/**
 * The chat template-proposal inventory as this build actually offers it.
 *
 * `matchTemplates()` below runs against the user's typed prompt, so this is
 * reached without any nav, URL, or catalogue: on an appliance, typing 빵집 /
 * 베이커리 / bakery / 스토어프론트 / storefront was enough to be offered — and
 * then to instantiate — a `kind: "storefront"` template. The route filter
 * and the Starters-catalogue filter both sat somewhere else entirely.
 *
 * Filtered by the template package's OWN `kind`, through the same marker
 * vocabulary and the same distribution predicate as the Starters catalogue
 * and the featured gallery. Under cloud this is a no-op.
 */
export const TEMPLATE_REGISTRY: TemplateRegistryEntry[] = TEMPLATE_REGISTRY_ALL.filter(
  (entry) => !applianceHidesCommerceMarker((entry.pkg as { kind?: string }).kind),
)

const norm = (s: string) => s.normalize('NFC').toLowerCase()

export function matchTemplates(prompt: string): TemplateRegistryEntry[] {
  const p = norm(prompt)
  return TEMPLATE_REGISTRY.filter((entry) =>
    (entry.pkg.terminologySurface?.terms ?? []).some((t) => t.length > 0 && p.includes(norm(t))),
  )
}
